import React from 'react';
import ContactUs from '../Components/ContactUs';


function ContactUsPage() {
  return (
    <>
    <div>
        <ContactUs/>
    </div>
    </>
  );
}

export default ContactUsPage;
